module.exports = __webpack_public_path__ + "img/mine_sel2.a50ac23f.png";